var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7008 21.5984H5.70077C4.37529 21.5984 3.30077 20.5239 3.30078 19.1984L3.30087 4.79842C3.30088 3.47295 4.3754 2.39844 5.70087 2.39844H16.5011C17.8266 2.39844 18.9011 3.47295 18.9011 4.79844V9.59844M7.50116 7.19844H14.7012M7.50116 10.7984H14.7012M14.7012 15.5524V18.4968C14.7012 19.9517 16.2526 21.2862 17.7075 21.2862C19.1625 21.2862 20.7012 19.9517 20.7012 18.4968V14.7776C20.7012 14.0073 20.2583 13.2256 19.2733 13.2256C18.2195 13.2256 17.7075 14.0073 17.7075 14.7776V18.3418M7.50116 14.3984H11.1012",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/DocumentIcon.d3e4595f3cd6b7e622b6ed5af093f1da.svg";
export { ForwardRef as ReactComponent };